import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const stickyCta = ($) => {
  const $hero = $(".wp-block-seven-shapes-section").eq(0);
  ScrollTrigger.create({
    trigger: $hero,
    start: "bottom 20%",
    endTrigger: ".footer",
    end: "top bottom",
    toggleClass: {
      targets: "body",
      className: "sticky-cta"
    }
  });
}

export default stickyCta